<template>
  <div>
    <!-- 搜索表单 -->
    <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
      <el-row :gutter="15">
        <el-col :md="7" :sm="12">
          <el-form-item label="日期范围:">
            <el-date-picker
              v-model="daterange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              class="ele-fluid"
              size="medium"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              :unlink-panels="true"
              @change="onDateRangeChoose"
            />
          </el-form-item>
        </el-col>
        <el-col :md="14" :sm="12">
          <div class="ele-form-actions">
            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询 </el-button>
            <el-button @click="(table.where = {}) && $refs.table.reload()">重置</el-button>
            <el-button @click="exportData" type="primary" icon="el-icon-download" class="ele-btn-icon">导出 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!-- 数据表格 -->
    <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row height="calc(100vh - 200px)">
      <template #default="{ index }">
        <el-table-column type="selection" width="45" align="center" fixed="left" />
        <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
        <el-table-column prop="studentName" label="学生姓名" show-overflow-tooltip min-width="110" />
        <el-table-column prop="behaviorName" label="行为名称" show-overflow-tooltip min-width="110" />
        <el-table-column prop="score" label="得分" width="80" align="center" show-overflow-tooltip />
        <el-table-column prop="picUrl" label="照片" show-overflow-tooltip :fit="true" align="center">
          <template #default="{ row }">
            <el-tag :type="row.picUrl ? 'success' : 'info'" @click="showImage(row)">{{ row.picUrl ? '预览' : '暂无' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="signPicUrl" label="签名" show-overflow-tooltip :fit="true" align="center">
          <template #default="{ row }">
            <el-image v-if="row.signPicUrl" :src="row.signPicUrl" alt="" fit="contain" />
            <el-tag v-else type="info">无签名</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="评分时间" show-overflow-tooltip width="180" align="center" />
        <el-table-column prop="teacherName" label="评分老师" show-overflow-tooltip min-width="110" align="center" />
      </template>
    </ele-data-table>
    <!-- 图片预览弹窗 -->
    <el-dialog title="提示" :visible.sync="image" width="30%" :destroy-on-close="true" :lock-scroll="false" :close-on-click-modal="false">
      <div v-if="picUrl.length > 0" style="display: flex">
        <el-image v-for="(item, index) in picUrl" :key="index" :src="item" alt="" width="250px" fit="contain" />
      </div>
      <div v-else>暂无图片数据</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="image = false">取 消</el-button>
        <el-button type="primary" @click="image = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { exportStudentBehaviorByClassId } from '@/config/api';

  export default {
    name: 'List',
    data() {
      return {
        table: {
          // 表格配置
          url: '/school/behavior/getStudentBehaviorByClassId',
          where: {
            startDate: this.formatDate(new Date()),
            overDate: this.formatDate(new Date()),
          },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [], // 表格选中数据
        daterange: null,
        classId: null,
        image: false,
        picUrl: [],
        aa: null,
      };
    },
    methods: {
      // 默认本月日期
      setSelectTime() {
        let _this = this;
        let date = new Date();
        let y = date.getFullYear();
        let m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();

        let start_month = y + '-' + '01';
        let end_month = `${y}-${m}`;

        let start_day = y + '-' + m + '-' + '01';
        let end_day = `${y}-${m}-${d}`;

        _this.aa = [start_month, end_month]; //默认月份区间
        _this.date = [start_day, end_day]; //默认日期区间  页面显示的
        this.table.where.startDate = start_day; // 传入后台的 开始时间
        this.table.where.overDate = end_day; // 传入后台的 结束时间
      },
      formatDate(date) {
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let hh = date.getHours();
        let mm = date.getMinutes();
        // let ss = date.getSeconds();
        if (m < 10) {
          m = 0 + '' + m;
        }
        if (d < 10) {
          d = 0 + '' + d;
        }
        if (hh < 10) {
          hh = 0 + '' + hh;
        }
        if (mm < 10) {
          mm = 0 + '' + mm;
        }
        // if (ss < 10) {
        //   ss = 0 + '' + ss;
        // }
        return y + '-' + m + '-' + d; //格式可以在这调整
      },
      /* 日期选择改变回调 */
      onDateRangeChoose() {
        if (this.daterange) {
          this.table.where.startDate = this.daterange[0];
          this.table.where.overDate = this.daterange[1];
        } else {
          this.table.where.startDate = null;
          this.table.where.overDate = null;
        }
      },
      //导出数据
      exportData() {
        if (this.daterange) {
          let data = {
            startDate: this.daterange[0],
            overDate: this.daterange[1],
            classId: this.classId,
            orgType: this.table.where.orgType,
          };
          exportStudentBehaviorByClassId(data).then((res) => {
            let blob = new Blob([res.data], {
              type: 'application/octet-stream',
            });
            let objectUrl = URL.createObjectURL(blob);
            // console.log(objectUrl)
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = objectUrl;
            let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
            // console.log(res.headers)
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            // console.log(link);
            link.click();
            document.body.removeChild(link); // 下载完成移除元素
            window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
          });
        }
      },
      showImage(row) {
        if (row.picUrl == '' || row.picUrl == null) {
          this.picUrl = [];
          return false;
        } else {
          this.image = true;
          this.picUrl = row.picUrl.split(',');
        }
      },
    },
  };
</script>

<style scoped></style>
